import { Injectable } from '@angular/core';
import * as alertify from 'alertifyjs';

@Injectable({
  providedIn: 'root',
})
export class AlertifyService {
  private mobileSizeScreen=800;
  constructor() {}

  confirm(message: string, okCallback: () => any) {
    alertify.confirm('Confirmación',message, (e: any) => {
      if (e) {
        okCallback();
      } else {
      }
    },null
    ).set('labels', {ok:'Aceptar', cancel:'Cancelar'})
    
  }
  confirmOrCancel(message: string, okCallback: () => any, cancelCallback: () => any) {
    alertify.confirm('Confirmación',message, (e: any) => {
      if (e) {
        okCallback();
      } else {
  
      }
    },(e: any) => {
      if (e) {
        cancelCallback();
      } else {
     
      }
    }
    ).set('labels', {ok:'Aceptar', cancel:'Cancelar'})
    
  }

  success(message: string) {
    if(this.mobileSizeScreen>=window.innerWidth){
      alertify.set('notifier','position', 'top-center');
    }else{
      alertify.set('notifier','position', 'bottom-right');
    }
    alertify.success(message);
  }

  error(message: string) {
    if(this.mobileSizeScreen>=window.innerWidth){
      alertify.set('notifier','position', 'top-center');
    }else{
      alertify.set('notifier','position', 'bottom-right');
    }
    alertify.error(message);
  }
  warning(message: string) {
    if(this.mobileSizeScreen>=window.innerWidth){
      alertify.set('notifier','position', 'top-center');
    }else{
      alertify.set('notifier','position', 'bottom-right');
    }
    alertify.warning(message);
  }

  message(message: string) {
    if(this.mobileSizeScreen>=window.innerWidth){
      alertify.set('notifier','position', 'top-center');
    }else{
      alertify.set('notifier','position', 'bottom-right');
    }
    alertify.message(message);
  }
}
